import { Box, type BoxProps } from "@chakra-ui/react";

function Badge({ children, ...props }: BoxProps) {
	return <Box {...props}>{children}</Box>;
}

export default Badge;
